import { useEffect } from 'react'

interface useInitProps {
  getRows: Function
  setRows: Function
  setFilterValuesLoaded: Function
  buttonClickCount: number
  bulkDeleteCunter: number
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    let filterValues: Array<any> = []
    const filterValuesPromise = props.getRows().then((data) => {
      filterValues = data
    })

    Promise.all([filterValuesPromise]).then(() => {
      props.setRows(filterValues)
      props.setFilterValuesLoaded(true)
    })
  }, [props.buttonClickCount, props.bulkDeleteCunter])
}

export default useInit
